<script>
import moment from 'moment'
import { formatPriceWithSign } from '@/utils/helpers'
import closeIcon from '@/assets/images/icons/close.svg?inline'

export default {
  name: 'sidebar-penalties',
  components: {
    closeIcon
  },
  data: () => ({
    isModalActive: false
  }),
  computed: {
    getAllPenalties() {
      return this.$store.getters['cart/getAllPenalties']
    }
  },
  methods: {
    formatDate: date => moment.unix(date).format('DD.MM.YYYY HH:MM'),
    formatPrice(price) {
      const slug = this.$store.getters['cart/getCartPrice'].currency
      const dictionary = this.$store.getters.getDictionary('cart.dictionaries.currencies')

      return formatPriceWithSign(price, slug, dictionary)
    },
  }
}
</script>

<template>
  <div>
    <a
      href="javascript:;"
      @click="isModalActive = true"
    >
      Условия сроков отмены
    </a>
    <b-modal
      :active.sync="isModalActive"
      scroll="keep"
      :width="560"
      :can-cancel="['escape', 'outside']"
    >
      <div class="card">
        <div class="modal__wrap card-content">
          <div class="modal__content">
            <div class="modal__header">
              <h2>Условия сроков отмены</h2>
              <close-icon
                @click="isModalActive = false"
              />
            </div>
            <div
              v-for="(service, serviceIndex) in getAllPenalties.penalties"
              :key="serviceIndex"
              class="modal__content-item"
            >
              <h2>{{ service.label }}</h2>
              <div
                class="modal__content-penalties-row"
                :class="{'modal__content-penalties-row--error': service.hasError}"
              >
                <template v-if="service.hasError">
                  <p>Ошибка загрузки штрафов</p>
                  <p
                    v-for="(error, errorIndex) in service.errors"
                    :key="`service-${serviceIndex}-error-${errorIndex}`"
                  >
                    {{ error.detail }}
                  </p>
                </template>
                <template v-else>
                  <div
                    v-for="(penalty, penaltyIndex) in service.collection"
                    :key="`service-${serviceIndex}-penalty-${penaltyIndex}`"
                    class="modal__content-penalties-row-item"
                  >
                    <p>{{ penalty.action }}</p>
                    <p>
                      c {{ formatDate(penalty.from) }}
                      <template v-if="penalty.to">
                        <br>
                        до {{ formatDate(penalty.to) }}
                      </template>
                    </p>
                    <p>{{ formatPrice(penalty.price.amount) }}</p>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>